<template>
  <div class="tw-flex tw-flex-col tw-items-center tw-my-4">
    <a @click="visitProfile">
      <img
        class="tw-rounded-full tw-border-4 tw-object-cover tw-cursor-pointer tw-w-48 tw-h-48 lg:tw-border-8 xl:tw-w-56 xl:tw-h-56"
        :src="thumb"
        :class="thumbBorderClass"
      >
    </a>
    <h4 class="tw-text-gray-800 tw-mt-3 tw-text-lg sm:tw-text-xl lg:tw-text-2xl tw-font-bold">
      {{ data.profile.nickname }}, {{ data.profile.age }}
    </h4>
    <div class="tw-mt-1 tw-italic tw-text-sm">
      {{ data.currentLocation.city }}
    </div>
    <div
      v-if="options.show.profession"
      class="tw-mt-1 tw-text-custom-blue tw-text-sm tw-text-center tw-hidden md:tw-inline-flex"
    >
      {{ data.profile.profession }}
    </div>
    <div
      v-if="options.show.lastOnline"
      class="tw-mt-1 tw-text-gray-500 tw-text-sm tw-text-center tw-hidden md:tw-inline-flex"
    >
      {{ dayjs(data.lastOnline).fromNow() }}
    </div>
    <div
      v-if="options.show.distanceToUser"
      class="tw-mt-1 tw-text-custom-blue tw-text-sm tw-text-center tw-hidden md:tw-inline-flex"
    >
      {{ data.distanceToUser }}
    </div>
  </div>
</template>

<script>
import profileFields from '@/mixins/profile-fields';

import dayjs from 'dayjs';

import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);


export default {
  mixins: [
    profileFields, //
  ],

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    route: {
      type: Object,
      default: () => ({
        name: 'profile',
      }),
    },
    options: {
      type: Object,
      default: () => ({
        show: {
          profession: true,
          distanceToUser: false,
          lastOnline: false,
        },
      }),
    },
  },

  computed: {
    dayjs() {
      return dayjs;
    },
  },

  mounted() {
    // console.log('ProfileGridItem.profile', this.data);
  },

  methods: {
    visitProfile(event) {
      console.log('this.profileLink', this.profileLink);

      if (event.metaKey || event.ctrlKey) {
        window.open(`/admin/profile/${this.data.profile.uuid}`, '_blank');
      } else {
        this.$router.push({
          name: this.route.name,
          params: { profile: this.data.profile.uuid },
        });
      }
    },
  },
};
</script>
